import angular from 'angular';
import template from './grad.html';
import {GradController} from './grad.controller.js';

const GradComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: GradController,
    controllerAs: 'vm'
};

export {GradComponent};



// WEBPACK FOOTER //
// ./app/components/grad/grad.component.js